import PaperMetadata from "components/PaperMetadata";
import { ResultFormat } from "components/Button/ResultFormatButton";
import { SearchResultPaperMetadataProps } from "../../../types";
import SearchResultSourceCheckbox from "features/SearchResultsList/components/SearchResultSourceCheckbox";
import { CITATION_WIDTH } from "../../../constants";

/**
 * @component SearchResultPaperMetadata
 * @description Wrapper around the base PaperMetadata component, including the add-as-source source checkbox
 */
export const SearchResultPaperMetadata = ({
  paper,
  badges,
  extraTags = [],
  showPaperDoi = false,
  isProcessingMetadata = false,
  hideCitations = false,
  resultFormat,
  showSourceCheckbox = false,
  useTwoRowLayout = false,
}: SearchResultPaperMetadataProps) => {
  const showTagsAsIcons = resultFormat !== ResultFormat.DEFAULT;

  return (
    <div className="flex flex-1 flex-shrink-1 items-center gap-3">
      {showSourceCheckbox && (
        <div className="flex justify-center" style={{ width: CITATION_WIDTH }}>
          <SearchResultSourceCheckbox paper={paper} />
        </div>
      )}
      <PaperMetadata
        paper={paper}
        showDoi={showPaperDoi}
        isProcessingMetadata={isProcessingMetadata}
        hideCitations={hideCitations}
        isCompact={showTagsAsIcons}
        badges={badges}
        extraTags={extraTags}
        useTwoRowLayout={useTwoRowLayout}
      />
    </div>
  );
};

export default SearchResultPaperMetadata;
